import { useQuery } from "@tanstack/react-query";
import { PermissionGroupsService } from "../Services/PermissionGroups.service";
import { PERMISSION_GROUPS_QUERY_KEY } from "../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";

export function useGetPermissionGroups(searchQuery?: string) {
  const {
    data: permissionGroups,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: [...PERMISSION_GROUPS_QUERY_KEY, searchQuery],
    queryFn: async () => {
      return await PermissionGroupsService.getPermissionGroups(searchQuery);
    },
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    permissionGroups: permissionGroups?.data?.data || [],
    isFetching,
  };
}
